function normalizeIso(iso: string) {
  // 把 .718506+08:00 → .718+08:00（JS Date 只能吃毫秒）
  return iso.replace(
    /(\.\d{3})\d+(?=(Z|[+-]\d{2}:\d{2})$)/,
    '$1'
  )
}

export function formatDateTime(iso: string) {
  if (!iso) return '—'

  const fixed = normalizeIso(iso)
  const d = new Date(fixed)

  if (Number.isNaN(d.getTime())) return '—'

  const yyyy = d.getFullYear()
  const mm = String(d.getMonth() + 1).padStart(2, '0')
  const dd = String(d.getDate()).padStart(2, '0')
  const hh = String(d.getHours()).padStart(2, '0')
  const mi = String(d.getMinutes()).padStart(2, '0')

  return `${yyyy}-${mm}-${dd} ${hh}:${mi}`
}
